interface AvisosProps {
    avisos?: (string | null | undefined)[] | null;
    inline?: boolean;
}

/** Avisos do backend (`avisos[]`), discretos, sem repetir o mesmo texto. */
export default function Avisos({ avisos, inline }: AvisosProps) {
    const lista = Array.from(new Set((avisos ?? []).filter((a): a is string => !!a && !!a.trim())));
    if (!lista.length) return null;
    return (
        <div className={inline ? 'avisos avisos-inline' : 'avisos'}>
            {lista.map(a => <div key={a}>ⓘ {a}</div>)}
        </div>
    );
}
